import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const PAY_ON_DELIVERY: PaymentMethod = {
    id: PAYMENT_METHOD_ID.PayOnDelivery,
    name: 'payondelivery',
    displayName: 'PayOnDelivery'
};
